import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs))
}

export const formatNumber = (num: bigint): string => {
  const n = BigInt(num)

  if (n >= BigInt('1000000000000000'))
    return n / BigInt('1000000000000000') + 'Q' // Quadrillion
  if (n >= BigInt('1000000000000')) return n / BigInt('1000000000000') + 'T' // Trillion
  if (n >= BigInt('1000000000')) return n / BigInt('1000000000') + 'B' // Billion
  if (n >= BigInt('1000000')) return n / BigInt('1000000') + 'M' // Million
  if (n >= BigInt('1000')) return n / BigInt('1000') + 'K' // Thousand

  return num.toString()
}
